<script>
import { BDatepicker } from 'buefy/src/components/datepicker';

export default {
  name: 'ModernDatepicker',
  extends: BDatepicker,
  computed: {
    listOfYears() {
      const latestYear = this.maxDate ? this.maxDate.getFullYear()
        : this.focusedDateData.year + this.yearsRange[1];

      let earliestYear = this.focusedDateData.year + this.yearsRange[0];
      if (this.minDate && this.minDate.getFullYear() > earliestYear) {
        earliestYear = Math.min(
          this.minDate.getFullYear(),
          this.focusedDateData.year,
        );
      }

      const arrayOfYears = [];
      for (let i = earliestYear; i <= latestYear; i += 1) {
        arrayOfYears.push(i);
      }

      return arrayOfYears.reverse();
    },
  },
};
</script>
